/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IAddContactInfo, ICheckoutGuestProfileViewProps, IShowContactInfo } from './citta-checkout-guest-profile';

export const ShowContactInfo: React.FC<IShowContactInfo> = (
    { showInfoProps, email, firstName, lastName, phoneNumber, companyName, editButton }) => (
    <Node {...showInfoProps}>
        {firstName}
        {lastName}
        {email}
        {phoneNumber}
        {companyName}
        {editButton}
    </Node>
);

export const B2BShowContactInfo: React.FC<IShowContactInfo> = (
    { showInfoProps, email, phoneNumber, companyName, editButton }) => (
    <Node {...showInfoProps}>
        {companyName}
        {/* {firstName}
        {lastName} */}
        {email}
        {phoneNumber}
        {editButton}
    </Node>
);


export const AddContactInfo: React.FC<IAddContactInfo> = ({
    addFormProps,
    submitButton,
    cancelButton,
    inputGroupProps,
    inputGroupFNameProps,
    inputGroupLastNameProps,
    inputGroupPhoneProps,
    inputGroupCompanyNameProps,
    label,
    error,
    input,
    fNameInput,
    lastNameError,
    lastNameInput,
    fNameError,
    fNameLabel,
    lNameLabel,
    phoneError,
    phoneLabel,
    phoneInput,
    companyNameError,
    companyNameLabel,
    companyNameInput
}) => (
    <Node {...addFormProps}>
      <Node {...inputGroupFNameProps}>
                    {fNameLabel}
                    {fNameError}
                    {fNameInput}
                </Node>
                <Node {...inputGroupLastNameProps}>
                    {lNameLabel}
                    {lastNameError}
                    {lastNameInput}
                </Node>
                <Node {...inputGroupProps}>
                    {label}
                    {error}
                    {input}
                </Node>
                <Node {...inputGroupPhoneProps}>
                    {phoneLabel}
                    {phoneError}
                    {phoneInput}
                </Node>
                <Node {...inputGroupCompanyNameProps}>
                    {companyNameLabel}
                    {companyNameError}
                    {companyNameInput}
                </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

export const B2BAddContactInfo: React.FC<IAddContactInfo> = ({
    addFormProps,
    submitButton,
    cancelButton,
    inputGroupProps,
    // inputGroupFNameProps,
    // inputGroupLastNameProps,
    inputGroupPhoneProps,
    inputGroupCompanyNameProps,
    label,
    error,
    // input,
    // fNameInput,
    // lastNameError,
    // lastNameInput,
    // fNameError,
    // fNameLabel,
    // lNameLabel,
    phoneError,
    phoneLabel,
    phoneInput,
    companyNameError,
    companyNameLabel,
    b2bcompanyNameInput,
    b2binput
}) => (
    <Node {...addFormProps}>
        <Node {...inputGroupCompanyNameProps}>
                    {companyNameLabel}
                    {companyNameError}
                    {b2bcompanyNameInput}
                </Node>
      {/* <Node {...inputGroupFNameProps}>
                    {fNameLabel}
                    {fNameError}
                    {fNameInput}
                </Node>
                <Node {...inputGroupLastNameProps}>
                    {lNameLabel}
                    {lastNameError}
                    {lastNameInput}
                </Node> */}
                <Node {...inputGroupProps}>
                    {label}
                    {error}
                    {b2binput}
                </Node>
                <Node {...inputGroupPhoneProps}>
                    {phoneLabel}
                    {phoneError}
                    {phoneInput}
                </Node>
        {submitButton}
        {cancelButton}
    </Node>
);

const CheckoutGuestProfileView: React.FC<ICheckoutGuestProfileViewProps> = ({ moduleProps, showContactInfo, addContactInfo, isB2B }) => {
    return (
        <Module {...moduleProps}>
            {isB2B? showContactInfo && <B2BShowContactInfo {...showContactInfo} /> : showContactInfo && <ShowContactInfo {...showContactInfo} />}
            {isB2B? addContactInfo && <B2BAddContactInfo {...addContactInfo} /> : addContactInfo && <AddContactInfo {...addContactInfo} />}
        </Module>
    );
};

export default CheckoutGuestProfileView;
